import { BaseCurrency, CashActionType } from '@eih-netbroker/common';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { FeedbackBox } from '../../../../shared/components/feedback-box/FeedbackBox';
import { Config } from '../../../../shared/config/config';
import classes from './CashActionNoSourceOrTargetAccountErrorFeedback.module.scss';

type CashActionNoSourceOrTargetAccountErrorFeedbackProps = {
  selectedCurrency: string;
  cashActionType: CashActionType;
  sourceAccountSelected?: boolean;
};

export const CashActionNoSourceOrTargetAccountErrorFeedback = ({
  cashActionType,
  selectedCurrency,
  sourceAccountSelected,
}: CashActionNoSourceOrTargetAccountErrorFeedbackProps) => {
  const { translation, translateWithParams } = useLocale();

  if (cashActionType === 'deposit' || cashActionType === 'allocation') {
    const title =
      selectedCurrency === BaseCurrency
        ? translation.cashAction[cashActionType].error.noConnectedAccountTitleHUF
        : translation.cashAction[cashActionType].error.noConnectedAccountTitle;

    const messageFirstHalf =
      selectedCurrency === BaseCurrency
        ? translation.cashAction[cashActionType].error.noConnectedAccountContentHUFFirstHalf
        : translation.cashAction[cashActionType].error.noConnectedAccountContentFirstHalf;

    const messageSecondHalf =
      selectedCurrency !== ''
        ? selectedCurrency === BaseCurrency
          ? translation.cashAction[cashActionType].error.noConnectedAccountContentHUFSecondHalf
          : translateWithParams(translation.cashAction[cashActionType].error.noConnectedAccountContentSecondHalf, {
              currency: selectedCurrency,
            })
        : translation.cashAction[cashActionType].error.noConnectedAccountContentSecondHalfWithoutCurrency;

    return (
      <FeedbackBox
        type="error"
        title={title}
        message={
          <>
            {messageFirstHalf}
            <a
              href={Config.Links.OldNetbroker}
              target={'_blank'}
              rel={'noreferrer noopener'}
              className={classes.link}
            >
              {translation.cashAction.contract}
            </a>
            {messageSecondHalf}
          </>
        }
      />
    );
  }

  // transfer
  return (
    <FeedbackBox
      type="error"
      title={
        translation.cashAction.transfer.error[
          sourceAccountSelected ? 'noSourceAccountTitleForSelectedSource' : 'noSourceAccountTitle'
        ]
      }
      message={translation.cashAction.transfer.error.noSourceAccountContent}
    />
  );
};
